import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import reducers from './reducers';
//Create Store
let enhancer=composeWithDevTools(applyMiddleware(thunk));
const reduxStore=createStore(reducers,enhancer);

export default reduxStore;